module.exports = __webpack_public_path__ + "img/digital-agency-light.a92da0ec.png";